<app-modal [modalTitle]="modalTitle" [modalId]="modalId" (closeModal)="closeModalButtonTrigger()">
  <div modalBody>
    <form>
      <div class="table-responsive scroll" [ngClass]="{ center: sharedItems.length === 0 }">
        <table class="table" *ngIf="sharedItems.length !== 0">
          <caption></caption>
          <thead class="header-style">
            <tr>
              <th class="header-cell cell-1">{{ 'SHARING' | translate }}</th>
              <th class="header-cell cell-2">{{ 'AUTHORITY' | translate }}</th>
              <th class="header-cell cell-3">{{ 'SHARE_NAME' | translate }}</th>
              <th class="header-cell cell-4">{{ 'NOTE' | translate }}</th>
              <th class="header-cell cell-5">{{ 'REMOVE' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of sharedItems; let i = index">
              <ng-container *ngIf="!item.groupShare">
                <tr>
                  <td>
                    <div class="person" [id]="'person' + i">
                      <div *ngIf="item.userInfoDto" class="person-picture">
                        <app-profile-image [firstName]="item.userInfoDto.firstName" [lastName]="item.userInfoDto.lastName" [image]="item.userInfoDto.imageId"></app-profile-image>
                      </div>
                      <div class="person-info">
                        <div class="name" *ngIf="hasRtukUrl; else noRtukUrl">
                          {{ trimStringPipe.transform(commonService.removeLastWord(item.userInfoDto?.firstName!) + ' ' + item.userInfoDto?.lastName, 20) }}</div
                        >
                        <ng-template #noRtukUrl>
                          <div class="name"> {{ trimStringPipe.transform(item.userInfoDto?.firstName! + item.userInfoDto?.lastName, 20) }}</div>
                        </ng-template>
                        <div class="email" title="{{ item.userInfoDto?.email }}">{{ item.userInfoDto?.email }}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="permission">
                      <select class="form-select form-control w-100" [(ngModel)]="item.permission" (change)="changePermission(item)" [ngModelOptions]="{ standalone: true }">
                        <option value="VIEW" [selected]="item.permission === 'VIEW'" [id]="'VIEWUSER' + i">{{ 'VIEW' | translate }}</option>
                        <option value="EDIT" [selected]="item.permission === 'EDIT'" [id]="'EDITUSER' + i">{{ 'EDIT' | translate }}</option>
                      </select>
                    </div>
                  </td>
                  <td>
                    <div class="mt-2 share" [id]="'shareType' + i">{{ item.shareName === null ? ('DIRECT_SHARE' | translate) : trimStringPipe.transform(item.shareName, 16) }}</div>
                  </td>
                  <td>
                    <div class="note mt-6" (click)="toggleNote(item)" [id]="'toggleNoteId' + i">
                      <img class="c-pointer" src="/assets/images/suite/storage/note.svg" alt="" id="note-icon" />
                    </div>
                  </td>
                  <td>
                    <div (click)="removeItem(item)" class="remove mt-2 ml-5" [id]="'removeUserId' + i">
                      <img class="c-pointer" src="/assets/images/suite/storage/close-danger.svg" alt="" id="remove-user-btn" />
                    </div>
                  </td>
                </tr>
                <tr [ngClass]="{ 'note-size': item.showInput }">
                  <td colspan="5" *ngIf="item.showInput" [id]="'shareNoteId' + i">
                    <header class="note-header mb-1">{{ 'SHARE_NOTE' | translate }}</header>
                    <input type="text" name="note" [(ngModel)]="item.shareNote" [ngModelOptions]="{ standalone: true }" [value]="item.shareNote" class="note-style form-control" />
                  </td>
                </tr>
              </ng-container>
              <ng-container *ngIf="item.groupShare">
                <tr>
                  <td>
                    <div class="person" [id]="'group' + i">
                      <div *ngIf="item.groupInfoDto" class="person-picture">
                        <img id="profile-image-placeholder" class="small-size" *ngIf="!item.groupInfoDto.imageId; else image" src="/assets/images/suite/groups/thumb.svg" alt="" />
                        <ng-template #image>
                          <app-profile-image [image]="item.groupInfoDto.imageId"></app-profile-image>
                        </ng-template>
                      </div>
                      <div class="person-info">
                        <div class="name">{{ item.groupInfoDto?.name }}</div>
                        <div class="email">{{ item.groupInfoDto?.userCount }}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="permission">
                      <select class="form-select form-control w-100" [(ngModel)]="item.permission" (change)="changePermission(item)" [ngModelOptions]="{ standalone: true }">
                        <option value="VIEW" [selected]="item.permission === 'VIEW'" [id]="'VIEWGROUP' + i">{{ 'VIEW' | translate }}</option>
                        <option value="EDIT" [selected]="item.permission === 'EDIT'" [id]="'EDITGROUP' + i">{{ 'EDIT' | translate }}</option>
                      </select>
                    </div>
                  </td>
                  <td>
                    <div class="mt-2 share">{{ item.shareName === null ? ('DIRECT_SHARE' | translate) : item.shareName }}</div>
                  </td>
                  <td>
                    <div class="note mt-6" (click)="toggleNote(item)">
                      <img class="c-pointer" src="/assets/images/suite/storage/note.svg" alt="" id="note-icon-2" />
                    </div>
                  </td>
                  <td>
                    <div (click)="removeItem(item)" class="remove mt-2 ml-5" [id]="'removeGroupId' + i">
                      <img class="c-pointer" src="/assets/images/suite/storage/close-danger.svg" alt="" id="remove-user-btn-2" />
                    </div>
                  </td>
                </tr>
                <tr [ngClass]="{ 'note-size': item.showInput }">
                  <td colspan="5" *ngIf="item.showInput">
                    <header class="note-header">{{ 'SHARE_NOTE' | translate }}</header>
                    <input
                      type="text"
                      name="note"
                      [(ngModel)]="item.shareNote"
                      [ngModelOptions]="{ standalone: true }"
                      [value]="item.shareNote"
                      class="note-style form-control"
                      [id]="'shareNoteId' + i"
                    />
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
        <div class="warning" *ngIf="sharedItems?.length === 0">
          <i class="ti ti-info-circle"></i> <span class="ml-2">{{ 'SHARE_REMOVE' | translate }}</span></div
        >
      </div>
    </form>
  </div>
  <div modalFooter>
    <button #btnCancelRef [hidden]="true" id="cancel-btn" data-bs-dismiss="modal"></button>
    <button class="btn btn-primary btn-md btn-style" [disabled]="submitted" (click)="this.selectedItem.encrypted ? encryptedSubmit($event) : onSubmit()" id="update-btn">
      {{ 'UPDATE' | translate }}
    </button>
  </div>
</app-modal>
